import React, { useContext, useEffect, useState, useMemo } from "react";
import DynamicTable from "components/ui/TableComponents/DynamicTable";
import { useFilter } from "context/FilterContext";
import SortContext from "context/SortContext";
import { useGlobalContext } from "context/GlobalContext";
import { useLocation, useNavigate } from "react-router-dom";
import apiClient from "lib/api-client";
import { useInfiniteQuery } from "@tanstack/react-query";
import { fetchClientsData } from "features/clients/ClientTable/useGetClientData";
import { useInView } from "react-intersection-observer";
import { findSpecificMenu, findSpecificPage, findSpecificSubMenu, findSpecificSubPage, hasAccessPage, hasAccessSubPage, isAllowed } from "utils/checkUserRigths";
import { usePermissions } from "context/PermissionsContext";
import { toast } from "react-toastify";
import { formatDateWithSuffix } from "utils/formatDate";
import { sortBy } from "lodash";

const Clients = () => {
  const { ref, inView } = useInView();
  const { filterValues, setIsSetFilter, setFilterValues, setBackendFilterValues, setFilterCount, setAppliedFilterValues } = useFilter();
  const { setSortOptions, setSelectedSortValue, setIsEdit, isEdit, setSearch, selectedSortValue, sortOptions, search } = React.useContext(SortContext);
  const {
    setCreateBtn,
    setCreateBtnName,
    setCreateBtnOption,
    setSearchPlaceHolder,
    setCartData,
    setFilterChangeCount,
    setDisplayCount,
    setFilterChangeDesignCount,
    setSearchResultCount,
    dynamicfilterCount,
    setDynamicFilterCount,
    filterChangeCount,
    filterChangeDesignCount,
    setSearchSuffix,
    setSectionCounts,
  } = useGlobalContext();

  const navigate = useNavigate();
  const location = useLocation();
  const [rowsData, setRowsData] = useState([]);

  const permissions = usePermissions();

  const hasAccessToPurchase = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permissions), "Purchases"), "view");
  const hasAccessToCatalog = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permissions), "Catalog"), "view");
  const hasAccessToDues_LedgerView = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permissions), "Dues & Ledger"), "view");
  const hasAccessToQuotes_OrdersView = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permissions), "Quotes & Orders"), "view");
  const hasAccessToWip = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permissions), "WIP"), "view");
  const hasAccessToNpdOrders = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permissions), "NPD Orders"), "view");
  const hasAccessToService_RequestView = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permissions), "Service Request"), "view");
  const hasAccessToRequest_Visit = hasAccessSubPage(findSpecificSubPage(findSpecificPage("Vision Web", permissions), "Request Visit"), "view");

  // const hasAccessToSeePurchase = hasAccessSubPage(findSpecificSubPage(findSpecificPage("Clients", permissions), "Purchases"), "view");
  // const hasAccessToSeeCatalog = hasAccessSubPage(findSpecificSubPage(findSpecificPage("Clients", permissions), "Catalog"), "view");
  // const hasAccessToSeeDues_Ledger = hasAccessSubPage(findSpecificSubPage(findSpecificPage("Clients", permissions), "Dues & Ledger"), "view");
  // const hasAccessToSeeQuotes_Orders = hasAccessSubPage(findSpecificSubPage(findSpecificPage("Clients", permissions), "Quotes & Orders"), "view");
  // const hasAccessToSeeWip = hasAccessSubPage(findSpecificSubPage(findSpecificPage("Clients", permissions), "WIP"), "view");
  // const hasAccessToSeeNpdOrders = hasAccessSubPage(findSpecificSubPage(findSpecificPage("Clients", permissions), "NPD Orders"), "view");
  // const hasAccessToSeeService_Request = hasAccessSubPage(findSpecificSubPage(findSpecificPage("Clients", permissions), "Service Request"), "view");
  // const hasAccessToSeeRequest_Visit = hasAccessSubPage(findSpecificSubPage(findSpecificPage("Clients", permissions), "Request Visit"), "view");

  const selectedOption = sortOptions.find((option) => option.id == selectedSortValue);

  const selectedSortBY = selectedOption?.sortBy;
  const selectedSortOrder = selectedOption?.order;
  const timeline = filterValues?.Timeline?.[0] || "All time";

  const { data, isLoading, isFetchingNextPage, fetchNextPage, hasNextPage, error } = useInfiniteQuery({
    queryKey: ["clientsData", { search, filterData: filterValues["Client Status"], sortBy: selectedSortBY, order: selectedSortOrder, timeline }],
    queryFn: fetchClientsData,
    // onSuccess: (data) => {
    //   setSectionCounts(data?.pages?.[0]?.sectionCounts || {});
    // },
    getNextPageParam: (lastPage) => {
      const { page, totalPages } = lastPage.pagination;

      if (page < totalPages) {
        return page + 1;
      }
      return undefined;
    },
  });

  const showTable = useMemo(() => hasAccessToPurchase || hasAccessToCatalog || hasAccessToDues_LedgerView || hasAccessToService_RequestView || hasAccessToRequest_Visit || hasAccessToQuotes_OrdersView || hasAccessToWip || hasAccessToNpdOrders, [permissions]);

  const headers = [
    { label: "Sr. No" },
    { label: "Name" },
    { label: "Code" },
    // { label: "Since" },
    { label: "Last Quote" },
    { label: "Articles" },
    { label: "D Wt" },
    { label: "G Wt" },
    { label: "N Wt" },
    { label: "City" },
    { label: "State" },
  ];

  // Handle row click
  // const handleRowClick = (clientCode, clientName) => {
  //   if (
  //     hasAccessToSeePurchase ||
  //     hasAccessToSeeCatalog ||
  //     hasAccessToSeeDues_Ledger ||
  //     hasAccessToSeeQuotes_Orders ||
  //     hasAccessToSeeWip ||
  //     hasAccessToSeeNpdOrders ||
  //     hasAccessToSeeService_Request ||
  //     hasAccessToSeeRequest_Visit
  //   ) {
  //     let state = {
  //       breadCrumbName: ["Purchases"],
  //       clientName,
  //     };

  //     sessionStorage.setItem("clientName", clientName);

  //     navigate(`/client-flow/${clientCode}/clients-purchases`, { state });
  //   } else {
  //     toast.error("You don’t have permission to access this flow.");
  //   }
  // };

  // console.log("filterValues===>>",filterValues?.Timeline[0])

  const handleRowClick = (clientCode, clientName, companyId) => {
    const routeMap = [
      { flag: hasAccessToPurchase, route: "clients-purchases", bread: "Purchases" },
      { flag: hasAccessToCatalog, route: "clients-catalog", bread: "Catalog" },
      { flag: hasAccessToDues_LedgerView, route: "dues-ledger", bread: "Dues Ledger" },
      { flag: hasAccessToQuotes_OrdersView, route: "quotes-orders", bread: "Quotes & Orders" },
      { flag: hasAccessToWip, route: "wip", bread: "WIP" },
      { flag: hasAccessToNpdOrders, route: "npd-orders", bread: "NPD Orders" },
      { flag: hasAccessToService_RequestView, route: "service-request", bread: "Service Request" },
      { flag: hasAccessToRequest_Visit, route: "request-visit", bread: "Request Visit" },
    ];

    const access = routeMap.find((item) => item.flag);

    if (!access) {
      toast.error("You don’t have permission to access this flow.");
      return;
    }

    let state = {
      breadCrumbName: [access.bread],
      clientName,
    };

    // console.log("companyId======>>>>",companyId)

    sessionStorage.setItem("clientName", clientName);
    if (companyId) {
      sessionStorage.setItem("companyId", companyId);
    } else {
      sessionStorage.removeItem("companyId", companyId);
    }

    navigate(`/client-flow/${clientCode}/${access.route}`, { state });
  };

  useEffect(() => {
    setSortOptions([
      // { id: 1, name: "Client Since (Oldest to Newest)", sortBy: "", order: "asc" },
      // { id: 2, name: "Client Since (Newest to Oldest)", sortBy: "", order: "desc" },

      { id: 1, name: "Client Name (A to Z)", sortBy: "Client Name", order: "asc" },
      { id: 2, name: "Client Name (Z to A)", sortBy: "Client Name", order: "desc" },

      { id: 3, name: "Last Quote (Oldest to Newest)", sortBy: "Last Order", order: "asc" },
      { id: 4, name: "Last Quote (Newest to oldest)", sortBy: "Last Order", order: "desc" },

      { id: 5, name: "Article Quantity (Low to High)", sortBy: "Articles", order: "asc" },
      { id: 6, name: "Article Quantity (High to Low)", sortBy: "Articles", order: "desc" },

      { id: 7, name: "Gold Net Weight (Low to High)", sortBy: "Gold Net Weight", order: "asc" },
      { id: 8, name: "Gold Net Weight (High to Low)", sortBy: "Gold Net Weight", order: "desc" },

      { id: 9, name: "Diamond Weight (Low to High)", sortBy: "Diamond Weight", order: "asc" },
      { id: 10, name: "Diamond Weight (High to Low)", sortBy: "Diamond Weight", order: "desc" },
    ]);

    setIsSetFilter(true);

    setSearchPlaceHolder("Search By Client Name or Code");
    setSectionCounts(data?.pages?.[0]?.sectionCounts || {});
    return () => {
      setSortOptions([]);
      // setSelectedSortValue(null);
      // setFilterValues({});
      setIsSetFilter(false);
      // setFilterCount(0);
      // setAppliedFilterValues({});
      setSearchPlaceHolder("");
    };
  }, [data]);

  useEffect(() => {
    sessionStorage.setItem("appliedSortValue", selectedSortValue);
  }, [selectedSortValue, sortOptions]);

  useEffect(() => {
    let filterData = {
      "Client Status": ["WIP", "Quotes & Order", "Dues", "Not Active", "Dead Since 1 year"],
      Timeline: ["All time"],
    };

    setBackendFilterValues(filterData);
    setFilterValues((prev) => ({
      ...filterData,
      "Client Status": prev["Client Status"]?.length ? prev["Client Status"] : filterData["Client Status"],
      Timeline: prev.Timeline ? prev.Timeline : filterData.Timeline,
    }));

    if (sessionStorage.getItem("filterChangeCount") == 0) {
      setFilterValues((prev) => ({
        ...filterData,
        "Client Status": prev["Client Status"]?.length ? prev["Client Status"] : filterData["Client Status"],
        Timeline: prev.Timeline ? prev.Timeline : filterData.Timeline,
      }));
    } else {
      const savedFilters = JSON.parse(sessionStorage.getItem("appliedFilterValues") || "{}");
      const newFilters = {
        "Client Status": savedFilters["Client Status"] || ["WIP", "Quotes & Order", "Dues", "Not Active", "Dead Since 1 year"],
        Timeline: savedFilters.Timeline || ["All time"],
      };
      setFilterValues(newFilters);
    }
  }, []);

  //API Call

  useEffect(() => {
    const handleScroll = () => {
      if (window.innerHeight + window.scrollY >= document.body.offsetHeight - 200 && hasNextPage && !isFetchingNextPage) {
        fetchNextPage();
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [hasNextPage, isFetchingNextPage]);

  useEffect(() => {
    if (inView && hasNextPage && !isFetchingNextPage) {
      fetchNextPage();
    }
  }, [inView, hasNextPage, isFetchingNextPage]);

  useEffect(() => {
    if (data?.pages) {
      const allClients = data?.pages?.flatMap((page) => page?.clientsData || []);
      setRowsData(allClients);
      if (search === "") {
        setDynamicFilterCount(true);
      }
      if (dynamicfilterCount) {
        setFilterChangeCount(data?.pages[0]?.totalCount || 0);
      } else {
        setFilterChangeCount(filterChangeCount);
      }
      setDisplayCount(true);
    }

    return () => {
      setFilterChangeCount(0);
      setDisplayCount(false);
    };
  }, [data]);

  // Prepare sections where each row cell has inline background color
  // Your gradient colors per row
  const rowColors = ["#C7B34E", "#C7B34E", "#C7B34E", "#B98D35", "#B98D35", "#B98D35", "#B16A63", "#B16A63", "#51A47A", "#51A47A", "#7F7F7F", "#7F7F7F", "#7F7F7F", "#7F7F7F", "#7F7F7F"];

  const sectionColors = {
    WIP: "#51A47A",
    "Quotes & Order": "#C7B34E",
    Dues: "#B98D35",
    "Dead Since 1 year": "#7F7F7F",
    "Not Active": "#B16A63",
  };

  // Prepare sections with clickable rows (entire row clickable)
  const sections = [
    {
      headers,
      rows: rowsData?.map((row, rowIndex) => {
        const columns = [
          `${rowIndex + 1}`,
          row.clientName,
          `#${row.clientCode}`,
          row?.lastOrderDate ? formatDateWithSuffix(row?.lastOrderDate) : "-",
          row.totalDesignCount,
          row.diaWeight,
          row.grossWeight,
          row.netWeight,
          row.city,
          row.state,
        ];

        return columns?.map((cell, cellIndex) => (
          <div
            key={`${rowIndex}-${cellIndex}`}
            style={{
              backgroundColor: sectionColors[row?.section] || "transparent",
              color: "#000",
              fontWeight: 400,
              fontFamily: "Karla",
              fontSize: "16px",
              width: "100%",
              height: "100%",
              padding: "8px 0",
              cursor: "pointer",
              whiteSpace: row?.lastOrderDate ? "nowrap" : "",
            }}
            onClick={() => showTable && handleRowClick(row?.clientCode, row?.clientName, row?.companyId)}
          >
            {cell}
          </div>
        ));
      }),
    },
  ];

  if (error) return <p>Error loading clients</p>;
  return (
    <div>
      <DynamicTable sections={sections} loading={isLoading} error={false} maxHeight={"73vh"} isFetchingNextPage={isFetchingNextPage} loadMoreRef={ref} />
    </div>
  );
};

export default Clients;
